/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from 'react';
import { useMutation } from '@apollo/client';
import styled from 'styled-components';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  Typography,
  FormControlLabel,
  Switch,
  TablePagination,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Input,
  InputLabel,
  InputAdornment,
} from '@material-ui/core';
import DeleteOutlinedOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { DeleteCourt } from '../../../../../components/mutations';
import { useColors } from '../../../../../hooks';
import { CourtProfileDialog } from './courtProfile';

export interface CreditorProps {
  courts?: any;
}

const defaultProps = {
  courts: [],
};

const StyledDiv = styled.div<{ borderColor: string }>`
  overflow: hidden;
  border-top: 8px solid ${({ borderColor }): string => borderColor};
`;
export const Courts: React.FC<CreditorProps> = ({ courts }) => {
  const { themeColors } = useColors();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState<string>('');
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(
    parseInt(localStorage.getItem('profileRowsPerPage') as string, 10) || 5,
  );

  // -------------------------------------delete op party -------------------------------------
  const [courtId, setCourtId] = useState(null);
  const [deleteTitle, setDeleteTitle] = useState(null);
  const [deleteCourt] = useMutation(DeleteCourt, {
    variables: { courtId },
  });
  // Modal Logic
  const [open, setOpen] = React.useState(false);
  const handleClose = (): void => {
    setOpen(false);
  };
  const handleCloseAgree = (): void => {
    setOpen(false);
    deleteCourt();
  };
  const handleClickOpen = (ID, TITLE): void => {
    setOpen(true);
    setCourtId(ID);
    setDeleteTitle(TITLE);
  };
  const handleSearch = (e): void => {
    setSearch(e.target.value);
  };
  // -------------------------------------end delete op party ----------------------------------
  const [openCourtProfile, setOpenCourtProfile] = useState(false);
  const handleOpenCourtProfile = (ID): void => {
    setOpenCourtProfile(true);
    setCourtId(ID);
  };
  const handleCloseCourtProfile = (): void => {
    setOpenCourtProfile(false);
  };
  useEffect(() => {
    if (localStorage.getItem('profileTableDense') === 'dense') {
      setDense(true);
    }
    if (localStorage.getItem('profileTableDense') === 'notDense') {
      setDense(false);
    }
    localStorage.setItem('profileRowsPerPage', rowsPerPage.toString());
  }, []);

  const handleChangeDense = (event: {
    target: { checked: React.SetStateAction<boolean> };
  }): void => {
    setDense(event.target.checked);
    if (event.target.checked) {
      localStorage.setItem('profileTableDense', 'dense');
    }
    if (!event.target.checked) {
      localStorage.setItem('profileTableDense', 'notDense');
    }
  };

  const handleChangePage = (
    _event: unknown,
    newPage: React.SetStateAction<number>,
  ): void => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: {
    target: { value: string };
  }): void => {
    setRowsPerPage(parseInt(event.target.value, 10));
    localStorage.setItem('profileRowsPerPage', event.target.value);
    setPage(0);
  };
  return (
    <>
      <StyledDiv borderColor={themeColors.mainColors.primaryColor}>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
          component="div"
          count={courts?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          style={{ float: 'right' }}
        />

        <div
          style={{
            float: 'left',
            marginBottom: -10,
            marginTop: 7,
            marginLeft: 15,
          }}
        >
          <FormControlLabel
            control={<Switch checked={dense} onChange={handleChangeDense} />}
            label="Dense padding"
          />
          <TextField
            id="input-with-icon-search"
            onChange={handleSearch}
            placeholder="Search"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircle />
                </InputAdornment>
              ),
            }}
          />
        </div>
      </StyledDiv>
      <div
        style={{
          borderTop: `2px solid ${themeColors.mainColors.primaryColor}`,
        }}
      />
      <Table aria-label="simple table" size={dense ? 'small' : 'medium'}>
        <TableHead>
          <TableRow style={{}}>
            <TableCell align="left">
              <Typography color="secondary">Name</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Open Cases</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Phone</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Fax</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Address</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">County</Typography>
            </TableCell>
            <TableCell align="left">
              <Typography color="secondary">Delete</Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {courts
            .filter(x =>
              x.court_name.toLowerCase().includes(search?.toLowerCase() || ''),
            )
            .sort((a, b) => a.court_name.localeCompare(b.court_name))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map(
              ({
                court_address_city,
                court_address_state,
                court_address_street,
                court_address_street2,
                court_address_zip,
                court_address_zip_4,
                court_county,
                court_efile_link,
                court_fax,
                court_id,
                court_mdj_number,
                court_name,
                court_phone,
                court_state,
                court_type,
                matters,
              }) => (
                <TableRow
                  key={court_id}
                  hover
                  onClick={(): void => handleOpenCourtProfile(court_id)}
                  style={{ cursor: 'pointer' }}
                >
                  <>
                    <TableCell component="th" scope="row">
                      {court_name}
                    </TableCell>
                    <TableCell align="left">{matters?.length}</TableCell>
                    <TableCell align="left">{court_phone}</TableCell>
                    <TableCell align="left">{court_fax}</TableCell>
                    <TableCell align="left">
                      {court_address_street &&
                        `${court_address_street ||
                          ''}, ${(court_address_street2 &&
                          `${court_address_street2}, `) ||
                          ''}${court_address_city ||
                          ''}, ${court_address_state ||
                          ''} ${court_address_zip || ''}`}
                    </TableCell>
                    <TableCell align="left">{court_county}</TableCell>
                    <TableCell align="left">
                      <DeleteOutlinedOutlined
                        color="primary"
                        onClick={(): void =>
                          handleClickOpen(court_id, court_name)
                        }
                      />
                    </TableCell>
                  </>
                </TableRow>
              ),
            )}
        </TableBody>
      </Table>

      <>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 150, 200]}
          component="div"
          count={courts?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonProps={{
            'aria-label': 'previous page',
          }}
          nextIconButtonProps={{
            'aria-label': 'next page',
          }}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          style={{ float: 'right' }}
        />
        <div
          style={{
            borderTop: `2px solid ${themeColors.mainColors.primaryColor}`,
          }}
        />
      </>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete Firm?</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete the firm {deleteTitle}? This action
            is permanent and cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            style={{ fontWeight: 'bold' }}
          >
            No, Cancel
          </Button>
          <Button
            onClick={handleCloseAgree}
            color="primary"
            autoFocus
            style={{ fontWeight: 'bold' }}
          >
            Yes, delete
          </Button>
        </DialogActions>
      </Dialog>
      {openCourtProfile && (
        <CourtProfileDialog
          open={openCourtProfile}
          handleClose={handleCloseCourtProfile}
          id={courtId}
        />
      )}
    </>
  );
};

Courts.defaultProps = defaultProps;
